<template>
  <Modal v-if="shown"
         :title= "$t('investor.exchange.modal.note.header.title')"
         @close="show(false)"
         :close-on-click-outside="false"
         :width="820"
  >
    <template v-slot:body>
      <span>{{ $t("investor.exchange.modal.note.header.subtitle") }}</span>
      <div>
        <div class="modal-content flex">
          <form class="modal-content modal-content--in-group">
            <div class="text_left base_padding flex_1">
              <md-field>
                <md-textarea
                    class="textarea note-textarea base_padding"
                    v-model="form.note"
                    v-validate="modelValidations.note"
                    :md-autogrow="true"
                    required
                ></md-textarea>
              </md-field>
            </div>
            <div class="flex flex_space base_padding">
              <div>
                <md-button @click="close" class="md-blank">
                  {{ $t("common.button.close") }}
                </md-button>
              </div>
              <div>
                <md-button @click="clear" :class="{ 'md-primary': isFormValid && existsInDb, 'margin_horizontal': true }">
                  {{ $t("common.button.delete") }}
                </md-button>
                <md-button @click="submit" :class="{ 'md-primary': isFormValid }">
                  {{ $t("common.button.submit") }}
                </md-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script>

import Modal from "@/components/templates/modal/Modal";
import {exchangeReceivablesApi} from "src/common/api/exchangeReceivablesApi";
import {validateRequiredFields} from "src/validation/validation";

export default {
  components: {
    Modal
  },
  data() {
    return {
      modelValidations: {
        note: {
          required: true
        }
      },
      shown: false,
      receivableId: null,
      tableParams: null,
      existsInDb: null,
      form: {
        note: null
      }
    };
  },
  methods: {
    show(value) {
      this.shown = value;
    },
    showNoteModal(data) {
      this.show(true);
      this.tableParams = data;
      this.receivableId = data.receivableId;
      this.form.note = data.comment;
      this.existsInDb = this.form.note != null
    },
    getData() {
      return {
        note: this.form.note
      };
    },
    close() {
      this.show(false)
    },
    clear() {
      if (validateRequiredFields(this.form, this.modelValidations) && this.existsInDb) {
        exchangeReceivablesApi.operation.saveNote({ receivableId: this.receivableId, note: null})
            .then(() => {
              this.tableParams.comment = null;
              this.toastSuccess();
            }).catch(this.toast);
        this.show(false)
      }
    },
    submit() {
      if (validateRequiredFields(this.form, this.modelValidations)) {
        exchangeReceivablesApi.operation.saveNote({ receivableId: this.receivableId, note: this.form.note})
            .then(() => {
              this.tableParams.comment = this.form.note;
              this.toastSuccess();
            }).catch(this.toast);
        this.show(false)
      }
    }
  },
  computed: {
    isFormValid() {
      return validateRequiredFields(this.form, this.modelValidations);
    }
  }
};
</script>

<style scoped>
  .note-textarea {
    min-height:200px;
    padding:12px;
    background-color:#E6E6E6;
  }
</style>